import { Tabs } from 'components/core-v2'

import { FeeBreakdownLoadingTable, FeeBreakdownTable } from './fee-breakdown-table'
import { FormattedFeeData } from './utils'

interface Props {
  data: FormattedFeeData
}

export const TotalTab = ({ data }: Props) => (
  <Tabs.Panel value="total">
    <FeeBreakdownTable data={data} />
  </Tabs.Panel>
)

export const TotalTabLoading = () => (
  <Tabs.Panel value="total">
    <FeeBreakdownLoadingTable />
  </Tabs.Panel>
)
